<script setup lang="ts">
import { getTextVariant } from '@/utils/stringUtils';
import { useI18nLocalize } from '@/i18n/i18nLocalize';

const props = defineProps<{
  data?: object;
  totalRoom: number;
  sumEconomy?: any;
  cabinsSum?: any;
}>();

const { i18nLocale } = useI18nLocalize();
const { $t } = i18nLocale(props.data.lang);
const columns = [
  {
    label: $t('client_copy.agent'),
    field: 'user'
  },
  {
    label: $t('client_copy.agency_name'),
    field: '-'
  },
  {
    label: $t('client_copy.phone'),
    field: 'phone'
  },
  {
    label: $t('client_copy.email'),
    field: 'email'
  },
  {
    label: $t('client_copy.group_name'),
    field: 'gName'
  },
  {
    label: $t('client_copy.type_of_quote'),
    field: 'gType'
  }
];

const sumBusiness = (airData: any) => {
  return airData.reduce((total: number, flight: any) => {
    return total + (flight.businessAdtNo ?? 0) + (flight.businessChdNo ?? 0);
  }, 0);
};
</script>

<template>
  <tr class="border-top-1 border-top-solid border-900">
    <td class="pt-2 vertical-align-top">
      <table>
        <thead>
          <tr>
            <th class="hidden" v-for="time in 2" :key="time"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="2" class="pb-2">
              <ul class="no-bullets">
                <li class="text-base underline font-bold">{{ $t('client_copy.agency_information') }}</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td class="width-200px text-base">
              <ul class="no-bullets w-full">
                <li v-for="column in columns" :key="column.field" class="height-18px my-1 font-bold">{{ column.label }} :</li>
                <li class="height-18px font-bold">{{ $t('client_copy.number_of_passengers') }} :</li>
              </ul>
            </td>
            <td class="width-200px text-left">
              <ul class="no-bullets w-full text-base">
                <li v-for="column in columns" :key="column.field" class="height-18px my-1">
                  <div class="width-200px overflow-hidden text-overflow-ellipsis">
                    {{ column.field === '-' ? column.field : column.field === 'gType' ? getTextVariant(data?.lang, data[column.field], data[`${column.field}Fr`]) : data[column.field] }}
                  </div>
                </li>
                <li class="height-18px">
                  <div v-if="!sumEconomy && !cabinsSum" id="total-rooms-id" class="width-200px overflow-hidden text-overflow-ellipsis">{{ `${data.numberOfPassengers}  ${totalRoom ? `(${totalRoom} ${$t('client_copy.rooms')})` : ''}` }}</div>
                  <div v-if="sumEconomy" class="width-200px overflow-hidden text-overflow-ellipsis">
                    {{ `${data.numberOfPassengers} (${sumEconomy(data.airs)} ${$t('worksheet.economy_class')}, ${sumBusiness(data.airs)} ${$t('worksheet.business')})` }}
                  </div>
                  <div v-if="cabinsSum" class="width-200px overflow-hidden text-overflow-ellipsis">{{ `${data.numberOfPassengers}  ${cabinsSum ? `(${cabinsSum} ${$t('worksheet.cabins')})` : ''}` }}</div>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>
